var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevice2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15382 12.8461V11.6538H9.84613V12.8461H4.15382ZM3.15382 9.84613V8.65383H10.8461V9.84613H3.15382ZM2.3077 20.9999C1.80257 20.9999 1.375 20.8249 1.025 20.4749C0.675 20.1249 0.5 19.6974 0.5 19.1923V1.8077C0.5 1.30257 0.675 0.875 1.025 0.525C1.375 0.175 1.80257 0 2.3077 0H11.6922C12.1974 0 12.625 0.175 12.975 0.525C13.325 0.875 13.5 1.30257 13.5 1.8077V19.1923C13.5 19.6974 13.325 20.125 12.975 20.475C12.625 20.825 12.1974 21 11.6922 21L2.3077 20.9999ZM1.99997 18.25V19.1923C1.99997 19.2692 2.03202 19.3397 2.09613 19.4039C2.16024 19.468 2.23077 19.5 2.3077 19.5H11.6922C11.7692 19.5 11.8397 19.468 11.9038 19.4039C11.9679 19.3397 12 19.2692 12 19.1923V18.25H1.99997ZM1.99997 16.75H12V4.24998H1.99997V16.75ZM1.99997 2.75003H12V1.80773C12 1.73079 11.9679 1.66027 11.9038 1.59615C11.8397 1.53205 11.7692 1.5 11.6922 1.5H2.3077C2.23077 1.5 2.16024 1.53205 2.09613 1.59615C2.03202 1.66027 1.99997 1.73079 1.99997 1.80773V2.75003Z",
    fill: "#082C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice2Icon);
export default __webpack_public_path__ + "static/media/device2Icon.2a4e7b1f3f6eb24a6c0e665b7f607575.svg";
export { ForwardRef as ReactComponent };